export default __webpack_public_path__ + "static/media/category-education.7ed2149c.jpg";